import { NotificationService } from './../../../services/notification.service';
import { InfoBoxService } from './../../../services/info-box.service';
import { PostsService } from './../../../services/posts.service';
import { animate, AnimationBuilder, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserRoleEnum } from 'src/app/enums/userRoleEnum';
import { AuthService } from 'src/app/services';
import { PostData } from '../models/post-data.model';
import { AdvanceDashboardService } from '../../bi-dashboard/dashboard.service';
import { DxDropDownBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-post-card',
    templateUrl: './post-card.component.html',
    styleUrls: ['./post-card.component.scss'],
    // host: {
    // 	// '[@expandedState]': 'stateName',
    // 	'(@expandedState.start)': 'captureStartEvent($event)',
    // 	'(@expandedState.done)': 'captureDoneEvent($event)',
    // },
    animations: [
        trigger('expandedState', [
            state('expanded', style({
                height: '*'
            }), { params: { expandedHeight: 0 } }),
            state('collapsed', style({
                height: '{{collapsedHeight}}px'
            }), { params: { collapsedHeight: 0 } }),
            transition('expanded => collapsed', [animate('0.5s ease-out')]),
            transition('collapsed => expanded', [animate('0.5s ease-in')])
        ])
    ],
    standalone: false
})
export class PostCardComponent implements OnInit, AfterViewInit {

	@Input() public cardItemData: { postData: PostData, expanded: boolean };

	@Output() public onDelete: EventEmitter<PostData> = new EventEmitter<PostData>();
	@Output() public onClick: EventEmitter<PostData> = new EventEmitter<PostData>();

	@Input() public minified: boolean = false;
	@Input() public hoverable: boolean;

	private _collapsedHeight?: number;

	public get collapsedHeight(): number {
		return this._collapsedHeight;
	}
	@Input()
	public set collapsedHeight(value: number) {
		if (!this._collapsedHeight) {
			this._collapsedHeight = value;
		}
	}
	@Input() public hasStateButton: boolean = true;

	@Input() public backgroundColor: string = "magenta";
	@Input() public infoTitleTextColor: string = "magenta";
	@Input() public mainTextColor: string = "magenta";
	@Input() public priorityIndicatorTextColor: string = "magenta";
	@Input() public priorityBackgroundColor: string = "magenta";

	public form: FormGroup;
	public controls: any;

	@Output() public onEditModeChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	private _isEditMode: boolean;
	public get isEditMode(): boolean {
		return this._isEditMode;
	}
	public set isEditMode(value: boolean) {
		this._isEditMode = value;

		this.cardItemData.expanded = true;

		// We let frame pass, so that edit mode is exited and we can calculate the correct content height.
		setTimeout(
			() => {
				if (this.contentElementRef != null && this.contentElementRef != undefined) {
					if (Math.abs(this.contentHeight - this.contentElementRef.nativeElement.offsetHeight) > 10) {
						this.onHeightChange.emit(this.contentElementRef.nativeElement.offsetHeight);
					}
				}

				this.calculateContentHeight();

				if (!this._isEditMode && this.contentHeight - this.collapsedHeight < 10) {
					this.cardItemData.expanded = false;
				}
			}
		);
		this.onEditModeChange.emit(this._isEditMode);
	}

	@Input() public startInEditMode: boolean = false;

	public isAdmin: boolean;

	public onSave(formValues: any) {
		

		if (this.form.invalid) {
			return;
		}

		const $this = this;

		formValues = { ...this.cardItemData.postData, ...formValues };

		let formData = formValues as PostData;
		if (formValues.icon.icon != null && formValues.icon.icon != undefined) {
			formData.icon = formValues.icon.icon;
		}

		this.postsService.upsertPost(formData).subscribe(
			(response) => {
				console.log("initializeColorValues -> getCoreSetting - response:", response);

				$this.infoBoxService.show({ message: response.message });

				if (response.success) {
					$this.cardItemData.postData = { ...this.cardItemData.postData, ...formValues };
				}

				$this.form = undefined;
				$this.isEditMode = false;

				

				$this.changeDetectorRef.markForCheck();
			},
			(error) => {
				console.error(error);

				$this.notificationService.error(error);
			}
		);
	}

	public stopEdit() {
		this.form = undefined;
		this.isEditMode = false;
		
		
	}

	public startEdit() {
		const {
			previewTitle,
			previewDescription,
			icon,
			isPriority,
			htmlText,
		} = { ...this.cardItemData.postData };

		this.form = this.formBuilder.group(
			{
				previewTitle: [previewTitle || "", [Validators.required, Validators.maxLength(512)]],
				previewDescription: [previewDescription || "", [Validators.maxLength(2048)]],
				icon: [icon || "", [Validators.maxLength(128)]],
				isPriority: [isPriority || false],
				htmlText: [htmlText || ""],
			}
		);

		

		this.controls = {
			previewTitle: this.form.get("previewTitle"),
			previewDescription: this.form.get("previewDescription"),
			icon: this.form.get("icon"),
			isPriority: this.form.get("isPriority"),
			htmlText: this.form.get("htmlText"),
		};

		if (this.icondata != null && this.icondata != undefined && this.cardItemData.postData.icon != null && this.cardItemData.postData.icon != undefined) {
			let indexcurrent = this.icondata.findIndex(x => x.icon == this.cardItemData.postData.icon);
			this.icon=null;
			if (indexcurrent != -1) {
				this.icon = this.icondata[indexcurrent];
			}
		}

		this.form.controls['icon'].setValue(this.icon);

		this.isEditMode = true;

		this.form.valueChanges.subscribe(console.log);
		this.form.valueChanges.subscribe((value) => { this.calculateContentHeight(); }); // console.log("value", value); });
	}

	public startDelete() {
		this.onDelete.emit(this.cardItemData.postData);
	}

	public get stateName() {
		return this.cardItemData.expanded ? 'expanded' : 'collapsed';
	}

	public expandedStateStart(event?: AnimationEvent) {
		
	}

	public expandedStateDone(event?: AnimationEvent) {
		

		this.calculateContentHeight();
	}
	icondata: any;
	icon: any;
	@ViewChild("dropDownBoxInstance", { static: false }) dropDownBoxInstance: DxDropDownBoxComponent;

	getIcons() {
		this.dashboardService.GetIcons().subscribe(response => {
			this.icondata = response;
		});
	}

	onSelectionChanged(e) {
		if (e.selectedRowsData && e.selectedRowsData[0] != null && e.selectedRowsData[0] != undefined) {
			this.icon = e.selectedRowsData[0];
		}
		this.dropDownBoxInstance.instance.close();
	}

	constructor(
		private elementRef: ElementRef,
		private authService: AuthService,
		private formBuilder: FormBuilder,
		private postsService: PostsService,
		private infoBoxService: InfoBoxService,
		private notificationService: NotificationService,
		private changeDetectorRef: ChangeDetectorRef,
		private animationBuilder: AnimationBuilder,
		private dashboardService: AdvanceDashboardService
	) { }

	ngOnInit() {
		this.isAdmin = this.authService.currentRole === UserRoleEnum.Admin;

		if (this.startInEditMode) {
			this.startEdit();
		}
		this.getIcons();
	}

	public getEndBackdropBackgroundStyle(): string {
		return `linear-gradient(0deg, ${this.cardItemData.postData.isPriority ? this.priorityBackgroundColor : this.backgroundColor} 30%, rgba(255,255,255,0) 100%)`;
	}

	@ViewChild("content", { static: false })
	public contentElementRef: ElementRef;

	public contentHeight: number;

	@Output() public onHeightChange: EventEmitter<number> = new EventEmitter<number>();

	private calculateContentHeight() {
		
		if (this.contentElementRef != null && this.contentElementRef != undefined) {
			this.contentHeight = this.contentElementRef.nativeElement.offsetHeight;
		}
		
	}

	ngAfterViewInit() {
		setTimeout(() => {
			this.calculateContentHeight();
		}, null);
	}
}
